export const timezones = [
  {
    position: "0",
    offsetHours: "-12",
    offsetMinutes: "0",
    description: "International Date Line West",
    displayTime: "(UTC-12:00)",
  },
  {
    position: "0",
    offsetHours: "-11",
    offsetMinutes: "0",
    description: "Coordinated Universal Time-11",
    displayTime: "(UTC-11:00)",
  },
  {
    position: "0",
    offsetHours: "-10",
    offsetMinutes: "0",
    description: "Hawaii",
    displayTime: "(UTC-10:00)",
  },
  {
    position: "1",
    offsetHours: "-10",
    offsetMinutes: "0",
    description: "Aleutian Island",
    displayTime: "(UTC-10:00)",
  },
  {
    position: "0",
    offsetHours: "-9",
    offsetMinutes: "-30",
    description: "Masquesas Islands",
    displayTime: "(UTC-09:30)",
  },
  {
    position: "1",
    offsetHours: "-9",
    offsetMinutes: "0",
    description: "Alaska",
    displayTime: "(UTC-09:00)",
  },
  {
    position: "2",
    offsetHours: "-9",
    offsetMinutes: "0",
    description: "Coordinated Universal Time-09",
    displayTime: "(UTC-09:00)",
  },
  {
    position: "0",
    offsetHours: "-8",
    offsetMinutes: "0",
    description: "Pacific Time (US and Canada)",
    displayTime: "(UTC-08:00)",
  },
  {
    position: "1",
    offsetHours: "-8",
    offsetMinutes: "0",
    description: "Baja California",
    displayTime: "(UTC-08:00)",
  },
  {
    position: "2",
    offsetHours: "-8",
    offsetMinutes: "0",
    description: "Coordinated Universal Time-08",
    displayTime: "(UTC-08:00)",
  },
  {
    position: "0",
    offsetHours: "-7",
    offsetMinutes: "0",
    description: "Arizona",
    displayTime: "(UTC-07:00)",
  },
  {
    position: "1",
    offsetHours: "-7",
    offsetMinutes: "0",
    description: "Chihuahua, La Paz, Mazatlan",
    displayTime: "(UTC-07:00)",
  },
  {
    position: "2",
    offsetHours: "-7",
    offsetMinutes: "0",
    description: "Mountain Time (US and Canada)",
    displayTime: "(UTC-07:00)",
  },
  {
    position: "0",
    offsetHours: "-6",
    offsetMinutes: "0",
    description: "Central America",
    displayTime: "(UTC-06:00)",
  },
  {
    position: "1",
    offsetHours: "-6",
    offsetMinutes: "0",
    description: "Central Time (US and Canada)",
    displayTime: "(UTC-06:00)",
  },
  {
    position: "2",
    offsetHours: "-6",
    offsetMinutes: "0",
    description: "Easter Island",
    displayTime: "(UTC-06:00)",
  },
  {
    position: "3",
    offsetHours: "-6",
    offsetMinutes: "0",
    description: "Guadalajara, Mexico City, Monterrey",
    displayTime: "(UTC-06:00)",
  },
  {
    position: "4",
    offsetHours: "-6",
    offsetMinutes: "0",
    description: "Saskatchewan",
    displayTime: "(UTC-06:00)",
  },
  {
    position: "0",
    offsetHours: "-5",
    offsetMinutes: "0",
    description: "Bogota, Lima, Quito, Rio Branco",
    displayTime: "(UTC-05:00)",
  },
  {
    position: "1",
    offsetHours: "-5",
    offsetMinutes: "0",
    description: "Eastern Time (US and Canada)",
    displayTime: "(UTC-05:00)",
  },
  {
    position: "2",
    offsetHours: "-5",
    offsetMinutes: "0",
    description: "Indiana (East)",
    displayTime: "(UTC-05:00)",
  },
  {
    position: "3",
    offsetHours: "-5",
    offsetMinutes: "0",
    description: "Chetumal",
    displayTime: "(UTC-05:00)",
  },
  {
    position: "4",
    offsetHours: "-5",
    offsetMinutes: "0",
    description: "Haiti",
    displayTime: "(UTC-05:00)",
  },
  {
    position: "5",
    offsetHours: "-5",
    offsetMinutes: "0",
    description: "Havana",
    displayTime: "(UTC-05:00)",
  },
  {
    position: "0",
    offsetHours: "-4",
    offsetMinutes: "0",
    description: "Atlantic Time (Canada)",
    displayTime: "(UTC-04:00)",
  },
  {
    position: "1",
    offsetHours: "-4",
    offsetMinutes: "0",
    description: "Georgetown, La Paz, Manaus, San Juan",
    displayTime: "(UTC-04:00)",
  },
  {
    position: "2",
    offsetHours: "-4",
    offsetMinutes: "0",
    description: "Asuncion",
    displayTime: "(UTC-04:00)",
  },
  {
    position: "3",
    offsetHours: "-4",
    offsetMinutes: "0",
    description: "Santiago",
    displayTime: "(UTC-04:00)",
  },
  {
    position: "4",
    offsetHours: "-4",
    offsetMinutes: "0",
    description: "Caracas",
    displayTime: "(UTC-04:00)",
  },
  {
    position: "5",
    offsetHours: "-4",
    offsetMinutes: "0",
    description: "Cuiaba",
    displayTime: "(UTC-04:00)",
  },
  {
    position: "6",
    offsetHours: "-4",
    offsetMinutes: "0",
    description: "Turks and Caicos",
    displayTime: "(UTC-04:00)",
  },
  {
    position: "0",
    offsetHours: "-3",
    offsetMinutes: "-30",
    description: "Newfoundland",
    displayTime: "(UTC-03:30)",
  },
  {
    position: "0",
    offsetHours: "-3",
    offsetMinutes: "0",
    description: "Brasilia",
    displayTime: "(UTC-03:00)",
  },
  {
    position: "1",
    offsetHours: "-3",
    offsetMinutes: "0",
    description: "Buenos Aires",
    displayTime: "(UTC-03:00)",
  },
  {
    position: "2",
    offsetHours: "-3",
    offsetMinutes: "0",
    description: "Cayenne, Fortaleza",
    displayTime: "(UTC-03:00)",
  },
  {
    position: "3",
    offsetHours: "-3",
    offsetMinutes: "0",
    description: "Greenland",
    displayTime: "(UTC-03:00)",
  },
  {
    position: "4",
    offsetHours: "-3",
    offsetMinutes: "0",
    description: "Montevideo",
    displayTime: "(UTC-03:00)",
  },
  {
    position: "5",
    offsetHours: "-3",
    offsetMinutes: "0",
    description: "Araguaina",
    displayTime: "(UTC-03:00)",
  },
  {
    position: "6",
    offsetHours: "-3",
    offsetMinutes: "0",
    description: "Saint Pierre and Miquelon",
    displayTime: "(UTC-03:00)",
  },
  {
    position: "7",
    offsetHours: "-3",
    offsetMinutes: "0",
    description: "Salvador",
    displayTime: "(UTC-03:00)",
  },
  {
    position: "0",
    offsetHours: "-2",
    offsetMinutes: "0",
    description: "Coordinated Universal Time-02",
    displayTime: "(UTC-02:00)",
  },
  {
    position: "0",
    offsetHours: "-1",
    offsetMinutes: "0",
    description: "Azores",
    displayTime: "(UTC-01:00)",
  },
  {
    position: "1",
    offsetHours: "-1",
    offsetMinutes: "0",
    description: "Cape Verde Is.",
    displayTime: "(UTC-01:00)",
  },
  {
    position: "0",
    offsetHours: "0",
    offsetMinutes: "0",
    description: "Coordinated Universal Time",
    displayTime: "(UTC)",
  },
  {
    position: "1",
    offsetHours: "0",
    offsetMinutes: "0",
    description: "Casablanca",
    displayTime: "(UTC+00:00)",
  },
  {
    position: "2",
    offsetHours: "0",
    offsetMinutes: "0",
    description: "Dublin, Edinburgh, Lisbon, London",
    displayTime: "(UTC+00:00)",
  },
  {
    position: "3",
    offsetHours: "0",
    offsetMinutes: "0",
    description: "Monrovia, Reykjavik",
    displayTime: "(UTC+00:00)",
  },
  {
    position: "0",
    offsetHours: "1",
    offsetMinutes: "0",
    description: "Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    displayTime: "(UTC+01:00)",
  },
  {
    position: "1",
    offsetHours: "1",
    offsetMinutes: "0",
    description: "Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    displayTime: "(UTC+01:00)",
  },
  {
    position: "2",
    offsetHours: "1",
    offsetMinutes: "0",
    description: "Brussels, Copenhagen, Madrid, Paris",
    displayTime: "(UTC+01:00)",
  },
  {
    position: "3",
    offsetHours: "1",
    offsetMinutes: "0",
    description: "Sarajevo, Skopje, Warsaw, Zagreb",
    displayTime: "(UTC+01:00)",
  },
  {
    position: "4",
    offsetHours: "1",
    offsetMinutes: "0",
    description: "West Central Africa",
    displayTime: "(UTC+01:00)",
  },
  {
    position: "5",
    offsetHours: "1",
    offsetMinutes: "0",
    description: "Windhoek",
    displayTime: "(UTC+01:00)",
  },
  {
    position: "0",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Amman",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "1",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Athens, Bucharest",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "2",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Beirut",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "3",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Cairo",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "4",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Harare, Pretoria",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "5",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "6",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Jerusalem",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "7",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Kaliningrad",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "8",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Tripoli",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "9",
    offsetHours: "2",
    offsetMinutes: "0",
    description: "Coordinated Universal Time+09",
    displayTime: "(UTC+02:00)",
  },
  {
    position: "0",
    offsetHours: "3",
    offsetMinutes: "0",
    description: "Baghdad",
    displayTime: "(UTC+03:00)",
  },
  {
    position: "1",
    offsetHours: "3",
    offsetMinutes: "0",
    description: "Kuwait, Riyadh",
    displayTime: "(UTC+03:00)",
  },
  {
    position: "2",
    offsetHours: "3",
    offsetMinutes: "0",
    description: "Moscow, St. Petersburg, Volgograd",
    displayTime: "(UTC+03:00)",
  },
  {
    position: "3",
    offsetHours: "3",
    offsetMinutes: "0",
    description: "Nairobi",
    displayTime: "(UTC+03:00)",
  },
  {
    position: "4",
    offsetHours: "3",
    offsetMinutes: "0",
    description: "Istanbul",
    displayTime: "(UTC+03:00)",
  },
  {
    position: "5",
    offsetHours: "3",
    offsetMinutes: "0",
    description: "Minsk",
    displayTime: "(UTC+03:00)",
  },
  {
    position: "0",
    offsetHours: "3",
    offsetMinutes: "30",
    description: "Tehran",
    displayTime: "(UTC+03:30)",
  },
  {
    position: "0",
    offsetHours: "4",
    offsetMinutes: "0",
    description: "Abu Dhabi, Muscat",
    displayTime: "(UTC+04:00)",
  },
  {
    position: "1",
    offsetHours: "4",
    offsetMinutes: "0",
    description: "Baku",
    displayTime: "(UTC+04:00)",
  },
  {
    position: "2",
    offsetHours: "4",
    offsetMinutes: "0",
    description: "Astrakhan, Ulyanovsk",
    displayTime: "(UTC+04:00)",
  },
  {
    position: "3",
    offsetHours: "4",
    offsetMinutes: "0",
    description: "Port Louis",
    displayTime: "(UTC+04:00)",
  },
  {
    position: "4",
    offsetHours: "4",
    offsetMinutes: "0",
    description: "Yerevan",
    displayTime: "(UTC+04:00)",
  },
  {
    position: "5",
    offsetHours: "4",
    offsetMinutes: "0",
    description: "Tbilisi",
    displayTime: "(UTC+04:00)",
  },
  {
    position: "6",
    offsetHours: "4",
    offsetMinutes: "0",
    description: "Izhevsk, Samara",
    displayTime: "(UTC+04:00)",
  },
  {
    position: "0",
    offsetHours: "4",
    offsetMinutes: "30",
    description: "Kabul",
    displayTime: "(UTC+04:30)",
  },
  {
    position: "0",
    offsetHours: "5",
    offsetMinutes: "0",
    description: "Ekaterinburg",
    displayTime: "(UTC+05:00)",
  },
  {
    position: "1",
    offsetHours: "5",
    offsetMinutes: "0",
    description: "Islamabad, Karachi",
    displayTime: "(UTC+05:00)",
  },
  {
    position: "2",
    offsetHours: "5",
    offsetMinutes: "0",
    description: "Tashkent",
    displayTime: "(UTC+05:00)",
  },
  {
    position: "0",
    offsetHours: "5",
    offsetMinutes: "30",
    description: "Chennai, Kolkata, Mumbai, New Delhi",
    displayTime: "(UTC+05:30)",
  },
  {
    position: "1",
    offsetHours: "5",
    offsetMinutes: "30",
    description: "Sri Jayawardenapura",
    displayTime: "(UTC+05:30)",
  },
  {
    position: "0",
    offsetHours: "5",
    offsetMinutes: "45",
    description: "Kathmandu",
    displayTime: "(UTC+05:45)",
  },
  {
    position: "0",
    offsetHours: "6",
    offsetMinutes: "0",
    description: "Astana",
    displayTime: "(UTC+06:00)",
  },
  {
    position: "1",
    offsetHours: "6",
    offsetMinutes: "0",
    description: "Dhaka",
    displayTime: "(UTC+06:00)",
  },
  {
    position: "2",
    offsetHours: "6",
    offsetMinutes: "0",
    description: "Omsk",
    displayTime: "(UTC+06:00)",
  },
  {
    position: "0",
    offsetHours: "6",
    offsetMinutes: "30",
    description: "Yangon (Rangoon)",
    displayTime: "(UTC+06:30)",
  },
  {
    position: "0",
    offsetHours: "7",
    offsetMinutes: "0",
    description: "Bangkok, Hanoi, Jakarta",
    displayTime: "(UTC+07:00)",
  },
  {
    position: "1",
    offsetHours: "7",
    offsetMinutes: "0",
    description: "Krasnoyarsk",
    displayTime: "(UTC+07:00)",
  },
  {
    position: "2",
    offsetHours: "7",
    offsetMinutes: "0",
    description: "Hovd",
    displayTime: "(UTC+07:00)",
  },
  {
    position: "3",
    offsetHours: "7",
    offsetMinutes: "0",
    description: "Novosibirsk",
    displayTime: "(UTC+07:00)",
  },
  {
    position: "4",
    offsetHours: "7",
    offsetMinutes: "0",
    description: "Tomsk",
    displayTime: "(UTC+07:00)",
  },
  {
    position: "5",
    offsetHours: "7",
    offsetMinutes: "0",
    description: "Barnaul, Gorno-Altaysk",
    displayTime: "(UTC+07:00)",
  },
  {
    position: "0",
    offsetHours: "8",
    offsetMinutes: "0",
    description: "Beijing, Chongqing, Hong Kong, Urumqi",
    displayTime: "(UTC+08:00)",
  },
  {
    position: "1",
    offsetHours: "8",
    offsetMinutes: "0",
    description: "Irkutsk, Ulaan Bataar",
    displayTime: "(UTC+08:00)",
  },
  {
    position: "2",
    offsetHours: "8",
    offsetMinutes: "0",
    description: "Kuala Lumpur, Singapore",
    displayTime: "(UTC+08:00)",
  },
  {
    position: "3",
    offsetHours: "8",
    offsetMinutes: "0",
    description: "Perth",
    displayTime: "(UTC+08:00)",
  },
  {
    position: "4",
    offsetHours: "8",
    offsetMinutes: "0",
    description: "Taipei",
    displayTime: "(UTC+08:00)",
  },
  {
    position: "5",
    offsetHours: "8",
    offsetMinutes: "0",
    description: "Ulaanbaatar",
    displayTime: "(UTC+08:00)",
  },
  {
    position: "0",
    offsetHours: "8",
    offsetMinutes: "30",
    description: "Pyongyang",
    displayTime: "(UTC+08:30)",
  },
  {
    position: "0",
    offsetHours: "8",
    offsetMinutes: "45",
    description: "Eucla",
    displayTime: "(UTC+08:45)",
  },
  {
    position: "0",
    offsetHours: "9",
    offsetMinutes: "0",
    description: "Osaka, Sapporo, Tokyo",
    displayTime: "(UTC+09:00)",
  },
  {
    position: "1",
    offsetHours: "9",
    offsetMinutes: "0",
    description: "Seoul",
    displayTime: "(UTC+09:00)",
  },
  {
    position: "2",
    offsetHours: "9",
    offsetMinutes: "0",
    description: "Yakutsk",
    displayTime: "(UTC+09:00)",
  },
  {
    position: "3",
    offsetHours: "9",
    offsetMinutes: "0",
    description: "Chita",
    displayTime: "(UTC+09:00)",
  },
  {
    position: "0",
    offsetHours: "9",
    offsetMinutes: "30",
    description: "Adelaide",
    displayTime: "(UTC+09:30)",
  },
  {
    position: "1",
    offsetHours: "9",
    offsetMinutes: "30",
    description: "Darwin",
    displayTime: "(UTC+09:30)",
  },
  {
    position: "0",
    offsetHours: "10",
    offsetMinutes: "0",
    description: "Brisbane",
    displayTime: "(UTC+10:00)",
  },
  {
    position: "1",
    offsetHours: "10",
    offsetMinutes: "0",
    description: "Canberra, Melbourne, Sydney",
    displayTime: "(UTC+10:00)",
  },
  {
    position: "2",
    offsetHours: "10",
    offsetMinutes: "0",
    description: "Guam, Port Moresby",
    displayTime: "(UTC+10:00)",
  },
  {
    position: "3",
    offsetHours: "10",
    offsetMinutes: "0",
    description: "Hobart",
    displayTime: "(UTC+10:00)",
  },
  {
    position: "4",
    offsetHours: "10",
    offsetMinutes: "0",
    description: "Vladivostok",
    displayTime: "(UTC+10:00)",
  },
  {
    position: "0",
    offsetHours: "10",
    offsetMinutes: "30",
    description: "Lord Howe Island",
    displayTime: "(UTC+10:30)",
  },
  {
    position: "0",
    offsetHours: "11",
    offsetMinutes: "0",
    description: "Magadan",
    displayTime: "(UTC+11:00)",
  },
  {
    position: "1",
    offsetHours: "11",
    offsetMinutes: "0",
    description: "Bougainville Island",
    displayTime: "(UTC+11:00)",
  },
  {
    position: "2",
    offsetHours: "11",
    offsetMinutes: "0",
    description: "Chokurdakh",
    displayTime: "(UTC+11:00)",
  },
  {
    position: "3",
    offsetHours: "11",
    offsetMinutes: "0",
    description: "Norfold Island",
    displayTime: "(UTC+11:00)",
  },
  {
    position: "4",
    offsetHours: "11",
    offsetMinutes: "0",
    description: "Sakhalin",
    displayTime: "(UTC+11:00)",
  },
  {
    position: "5",
    offsetHours: "11",
    offsetMinutes: "0",
    description: "Solomon Is., New Caledonia",
    displayTime: "(UTC+11:00)",
  },
  {
    position: "0",
    offsetHours: "12",
    offsetMinutes: "0",
    description: "Auckland, Wellington",
    displayTime: "(UTC+12:00)",
  },
  {
    position: "1",
    offsetHours: "12",
    offsetMinutes: "0",
    description: "Fiji",
    displayTime: "(UTC+12:00)",
  },
  {
    position: "2",
    offsetHours: "12",
    offsetMinutes: "0",
    description: "Coordinated Universal Time+12",
    displayTime: "(UTC+12:00)",
  },
  {
    position: "3",
    offsetHours: "12",
    offsetMinutes: "0",
    description: "Anadyr, Petropavlovsk-Kamchatsky",
    displayTime: "(UTC+12:00)",
  },
  {
    position: "0",
    offsetHours: "12",
    offsetMinutes: "45",
    description: "Chatham Islands",
    displayTime: "(UTC+12:45)",
  },
  {
    position: "0",
    offsetHours: "13",
    offsetMinutes: "0",
    description: "Nuku'alofa",
    displayTime: "(UTC+13:00)",
  },
  {
    position: "1",
    offsetHours: "13",
    offsetMinutes: "0",
    description: "Samoa",
    displayTime: "(UTC+13:00)",
  },
  {
    position: "0",
    offsetHours: "14",
    offsetMinutes: "0",
    description: "Kiritimati Island",
    displayTime: "(UTC+14:00)",
  },
];

export const daylightMode = [
  { value: "recurring", label: "Recurring" },
  { value: "nonRecurring", label: "Non-Recurring" },
  { value: "disabled", label: "Disabled" },
];

export const daylightMinutes = [
  { value: "0", label: "0" },
  { value: "15", label: "15" },
  { value: "30", label: "30" },
  { value: "45", label: "45" },
];

export const offsetMinutes = [
  { value: "30", label: "30" },
  { value: "60", label: "60" },
];

export const daylightWeekNumbers = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const weekdays = [
  { value: "1", label: "Monday" },
  { value: "2", label: "Tuesday" },
  { value: "3", label: "Wednesday" },
  { value: "4", label: "Thurday" },
  { value: "5", label: "Friday" },
  { value: "6", label: "Saturday" },
  { value: "7", label: "Sunday" },
];

export const months = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const hours = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
];

export const days = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
  { value: "26", label: "26" },
  { value: "27", label: "27" },
  { value: "28", label: "28" },
  { value: "29", label: "29" },
  { value: "30", label: "30" },
  { value: "31", label: "31" },
];

export default timezones;
